import {
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	EventEmitter,
	Input,
	OnInit,
	Output,
	TemplateRef,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "ic-paragraph",
	templateUrl: "./paragraph.component.html",
	styleUrls: ["./paragraph.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ParagraphComponent implements OnInit {
	@Input() label?: string;
	@Input() form?: UntypedFormGroup;
	@Input() control?: string;
	@Input() editText: string;
	@Input() saveText: string;
	@Input() activateText: string;
	@Input() cancelText: string;
	@Input() showFormOnEmpty = false;
	@Input() type: "default" | "primary" | "success" | "danger" | "warning" | "info" = "default";
	@Output() cancelEdit = new EventEmitter<void>();
	@Output() save = new EventEmitter<void>();

	@ContentChild("editTmpl", { static: false }) editTemplate: TemplateRef<any>;

	showEdit = false;
	showForm = true;

	edit() {
		this.showEdit = true;
		this.showForm = true;
	}

	activateForm() {
		this.showForm = true;
	}

	saveParagraph() {
		this.showEdit = false;
		this.save.emit();
	}

	cancelParagraph() {
		this.showEdit = Boolean(!this.form.getRawValue()[this.control]);
		this.showForm = Boolean(this.form.getRawValue()[this.control]);

		this.cancelEdit.emit();
	}

	ngOnInit() {
		// If there's no edit template, we cannot edit this paragraph, so we don't have to deal with the empty value. If the paragraph does not exist yet, we can return as well
		if (!this.editTemplate) {
			return;
		}

		// In this case, we can edit the paragraph. If the form is empty, we automatically make the edit template visible if showFormOnEmpty is true
		this.showEdit = !this.form.getRawValue()[this.control];
		this.showForm = this.showFormOnEmpty;
	}
}
